import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en';
import es from './locales/es';

// Recursos en inglés y español
const resources = {
  en: { translation: en.translation },
  es: { translation: es.translation }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Establecer inglés como idioma por defecto
    fallbackLng: 'en', // Fallback al inglés si no encuentra la traducción
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'language'
    },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
    },
    updateMissing: true,
    saveMissing: false,
    load: 'languageOnly',
    initImmediate: false,
    preload: ['en', 'es'],
    returnNull: false,
    returnEmptyString: false,
    missingKeyHandler: function(_lng, _ns, key) { return key; },
    parseMissingKeyHandler: function(key) { return key; },
  });

export default i18n; 